<template>
  <section class="container columns" style="margin: 2% auto">
    <form v-on:submit.prevent="createCropTradeName" class="column is-half">
      <b-field label="Crop Trade Name">
        <b-input
          v-model="newCropTradeName.cropTradeName"
          placeholder
          required
        ></b-input>
      </b-field>
      <div>
        <button class="button is-primary" type="submit">Create</button>
      </div>
    </form>
  </section>
</template>

<script>
import { currencies } from "@/helpers";
import { mapGetters } from "vuex";
export default {
  name: "newCropTradeName",
  data() {
    return {
      newCropTradeName: {
        cropTradeName: ""
      }
    };
  },
  created() {},
  methods: {
    createCropTradeName() {
      const loading = this.$loading.open();

      this.$store
        .dispatch("createCropTradeName", this.newCropTradeName)
        .then(newCropTradeName => {
          loading.close();
          this.$router.push({ cropTradeName: "Crop Trade Names" });
          this.$toasted.global.success("Crop Trade Name Successfully Created!");
        })
        .catch(e => {
          console.log("Exception when creating new Crop Trade Name", e);
          loading.close();
          this.$toasted.global.error("Failed to create crop Trade Name.");
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/CropManager/NewCropTradeName.vue